import { createElement } from 'react'
import type { ComponentType } from 'react'
import type { match, RouteProps } from 'react-router'
import { matchPath } from 'react-router'
import { Route, useLocation } from 'react-router-dom'
import { useLocaleStrippedLocation } from './useLocaleStrippedLocation'

type RoutePropsWithComputedMatch = RouteProps & {
  computedMatch?: match | null
}

const RouteWithComputedMatch = Route as ComponentType<RoutePropsWithComputedMatch>

export default function LocaleAwareRoute(props: RouteProps) {
  const location = useLocation()
  const matchLocation = useLocaleStrippedLocation()
  const computedMatch = props.path ? matchPath(matchLocation.pathname, props) : undefined

  return createElement(RouteWithComputedMatch, {
    ...props,
    location,
    computedMatch,
  })
}
